import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=8806eff0&scoped=true"
import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8806eff0",
  null
  
)

export default component.exports